import{TextTrackKinds as r}from"../../../../../enums";export var isCc1Track=function(n){return n.kind===r.SUBTITLES&&"CC1"===n.label&&""===n.language};